import { render, staticRenderFns } from "./BuscaProduto.vue?vue&type=template&id=b7097e88&scoped=true&"
import script from "./BuscaProduto.vue?vue&type=script&lang=js&"
export * from "./BuscaProduto.vue?vue&type=script&lang=js&"
import style0 from "./BuscaProduto.vue?vue&type=style&index=0&id=b7097e88&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7097e88",
  null
  
)

export default component.exports